module.exports = __webpack_public_path__ + "static/media/CertiK_Audit_Report.2101b8f7.pdf";